<!-- @format -->

<template>
  <TableFull v-model="control" :headers="headers" :items="items" dense>
    <template v-slot:date="{ item }">
      {{ formatFullDate(item.date) }}
    </template>
    <template v-slot:price="{ item }">
      {{ formatMoneyS(item.price) }}
    </template>
    <template v-slot:actions="{ item }">
      <TheToolTip label="Visualizar">
        <TableIconButton icon="fa-eye" @click="navigate('movementUpdate', { id: item.idMovement }), true" />
      </TheToolTip>
    </template>
  </TableFull>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import { get } from '@/crud'
import { useNavigation } from '@/composables/useNavigation'
import { useFormat } from '@/composables/useFormat'
//  Composables
const { navigate } = useNavigation()
const { formatFullDate, formatMoneyS, formatDate } = useFormat()
// Props
const props = defineProps({
  id: [String, Number],
})
// Controller
const api = 'itemMovement'

const items = ref([])

const control = ref({
  page: 1,
  limit: 20,
  pages: 0,
  total: 0,
  order: [{ direction: 'DESC', column: 'date', name: 'Data', table: 'movement', orderField: 'date' }],
})

const headers = ref([
  { title: 'Data', field: 'date', table: 'movement', orderField: 'date' },
  { title: 'Cód. Movimentação', field: 'idMovement' },
  { title: 'Depósito', field: 'destinationName', table: 'destinationWarehouse', orderField: 'name' },
  { title: 'Fornecedor', field: 'supplierName', table: 'supplier', orderField: 'name' },
  { title: 'Quantidade', field: 'quantity' },
  { title: 'Preço und', field: 'price' },
  { title: 'Ações', field: 'actions', itemClass: 'w-1/12', disableOrder: true, headerClass: 'justify-center' },
])

const loadItems = async () => {
  const filters = [
    {
      column: 'idItem',
      value: props.id,
      operator: '=',
    },
    {
      column: 'type',
      value: 'entry',
      operator: '=',
      table: 'movement',
    },
  ]

  const query = {
    params: {
      page: control.value.page,
      limit: control.value.limit,
      order: control.value.order,
      filters,
    },
  }

  const raw = await get(api, query)
  items.value = raw.data
  control.value.pages = Math.ceil(raw.total / control.value.limit)
  control.value.total = raw.total
}
// Watchers
watch(
  () => props.id,
  () => {
    loadItems()
  },
  { deep: true },
)

watch(
  () => control.value,
  () => {
    loadItems()
  },
  { deep: true },
)

// Life Cycle
onMounted(() => {
  loadItems(1)
})
</script>
